import { put } from 'redux-saga/effects';

import * as Actions from '../../actions';
import * as Constants from '../../constants';
import { ApiErrorTypes } from '../../lib/error/ApiError';

export const ANON_LOGIN = 'ANON_LOGIN';
export const REGISTER = 'REGISTER';

export function* onApiFail(action) {
  const { error, type } = action;
  const actionPrefix = type.slice(0, type.indexOf('_FAIL'));
  switch (error.errorType) {
    case ApiErrorTypes.READONLY_MODE:
      yield put(Actions.Modal.closeModal());
      yield put(Actions.Modal.openModalReadOnlyMode());
      break;

    case ApiErrorTypes.LISTENER_SUSPENDED:
      yield put(
        Actions.Modal.openModalCoachmark(
          Constants.ServiceErrors.ServiceErrorMessages.suspendedListenerErrorMessage,
        ),
      );
      yield put(Actions.UseCases.signOut());
      break;

    case ApiErrorTypes.INVALID_REQUEST:
      if (actionPrefix === 'REGISTER') {
        // No auth token and attempting to register indicates read only mode
        yield put(Actions.Modal.closeModal());
        yield put(Actions.Modal.openModalReadOnlyMode());
      }
      break;

    default:
      break;
  }

  return;
}
